module.exports = __webpack_public_path__ + "bin/20632bf5b3a6c5e22e1893f23107d01c.png";